<div class="flex justify-center items-center min-h-screen bg-gradient-to-r from-[#C6A150] to-[#012E26] p-4 relative mt-[80px]">
    <div class="absolute inset-0 bg-cover bg-center opacity-20"
         style="background-image: url('https://source.unsplash.com/1600x900/?abstract,technology');"></div>

    <div class="w-full max-w-4xl bg-white bg-opacity-90 p-8 rounded-2xl shadow-2xl relative z-10">
        <h2 class="text-3xl font-bold text-center text-[#012E26] mb-6">🚀 Admission Open for 2025: Apply Today! 🎓</h2>
        <form [formGroup]="applyNowForm">
            <div class="grid grid-cols-1 md-grid-cols-2 gap-6">
                <div>
                    <label class="block text-gray-700 font-semibold">Full Name</label>
                    <input type="text" placeholder="Enter Your Full Name"
                           formControlName="name"
                           class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                </div>
                <div *ngIf="url === '/international-admissions/apply-form'">
                    <label class="block text-gray-700 font-semibold">Country</label>
                    <select formControlName="country_id"
                            class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                        <option value="">Select Country</option>
                        <option *ngFor="let country of countries;" value="{{country?.id}}">{{ country?.name }}</option>
                    </select>
                </div>

                <div>
                    <label class="block text-gray-700 font-semibold">Email ID</label>
                    <input type="email" placeholder="Enter Your Email ID"
                           formControlName="email"
                           class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                </div>
                <div class="flex gap-2">
                    <div class="w-[30%]" *ngIf="url === '/international-admissions/apply-form'">
                        <label class="block text-gray-700 font-semibold">ISD</label>
                        <input type="number" placeholder="Enter ISD"
                               formControlName="isd"
                               class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                    </div>
                    <div class="w-full">
                        <label class="block text-gray-700 font-semibold">Contact No.</label>
                        <input type="number" placeholder="Contact Number"
                               formControlName="contact"
                               class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                    </div>
                </div>

                <div>
                    <label class="block text-gray-700 font-semibold">Program</label>
                    <select formControlName="program_id"
                            class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm"
                            (change)="getCourses()">
                        <option value="">Select Program</option>
                        <option *ngFor="let program of programs;"
                                value="{{program?.program?.id}}">{{ program?.program?.name }}
                        </option>
                    </select>
                </div>

                <!--<div>
                    <label class="block text-gray-700 font-semibold">Course</label>
                    <select formControlName="course_id"
                            class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm"
                            (change)="getBranches()">
                        <option value="">Select Course</option>
                        <option *ngFor="let course of courses;" value="{{course?.course?.id}}">{{ course?.course?.name || 'No Branch' }}</option>
                    </select>
                </div>

                <div>
                    <label class="block text-gray-700 font-semibold">Branch</label>
                    <select formControlName="branch_id"
                            class="w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-[#C6A150] focus:outline-none shadow-sm">
                        <option value="">Select Branch</option>
                        <option value="" *ngIf="!branches">No Branch</option>
                        <option *ngFor="let branch of branches;" value="{{branch?.branch?.id}}">{{ branch?.branch?.name }}</option>
                    </select>
                </div>-->

                <div class="relative">
                    <label class="block text-gray-700 font-semibold">Course</label>
                    <input
                        type="text"
                        (keyup)="filterCourses($event.target.value)"
                        (focus)="showCourseDropdown = true"
                        (blur)="hideDropdownWithDelay('COURSE')"
                        formControlName="selectedCourse"
                        placeholder="Select Course"
                        class="w-full border border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <ul
                        *ngIf="showCourseDropdown && filteredCourses?.length > 0"
                        class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                    >
                        <li
                            *ngFor="let course of filteredCourses"
                            (mousedown)="selectCourse(course)"
                            class="p-2 hover:bg-blue-100 cursor-pointer"
                        >
                            {{ course?.course?.name || 'No Courses' }}
                        </li>
                    </ul>
                </div>


                <div class="relative">
                    <label class="block text-gray-700 font-semibold">Branch</label>
                    <input
                        type="text"
                        (keyup)="filterBranch($event.target.value)"
                        (focus)="showBranchDropdown = true"
                        (blur)="hideDropdownWithDelay('BRANCH')"
                        formControlName="selectedBranch"
                        placeholder="Select Branch"
                        class="w-full border border-blue-50 p-2 mb-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                    <ul
                        *ngIf="showBranchDropdown && filteredBranch?.length > 0"
                        class="absolute z-10 w-full bg-white border border-blue-100 rounded shadow mt-1 max-h-[300px] h-[200px] overflow-y-scroll"
                    >
                        <li
                            *ngFor="let branch of filteredBranch"
                            (mousedown)="selectBranch(branch)"
                            class="p-2 hover:bg-blue-100 cursor-pointer"
                        >
                            {{ branch?.branch?.name || 'No Branches' }}
                        </li>
                    </ul>
                </div>

            </div>
        </form>
        <div class="flex justify-center mt-6">
            <button
                class="bg-gradient-to-r from-[#C6A150] to-[#012E26] text-white px-8 py-3 rounded-xl font-semibold shadow-lg hover:opacity-90 transition duration-300"
                (click)="submit()">
                APPLY NOW ➜
            </button>
        </div>
    </div>
</div>
